import React from 'react';

import ActionButton from '../../elements/ActionButton';
import ColoredStatus from '../../elements/common/ColoredStatus';

import { PERMISSION } from 'crm/helpers/Permissions';

function DepositsTableShort({ deposits }) {
    function getDepositsList() {
        return deposits.map(({ id, token, payment_method_name, amount_formatted, status }) => (
            <tr key={id}>
                <td>{token}</td>
                <td>{payment_method_name}</td>
                <td>{amount_formatted}</td>
                <td>
                    <ColoredStatus status={status} colorset="deposits" />
                </td>
                <td>
                    <ActionButton title="open" url={`/deposits/${id}`} permissions={[PERMISSION.VIEW_DEPOSIT]} />
                </td>
            </tr>
        ));
    }

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Token</th>
                    <th>Payment method</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th />
                </tr>
            </thead>
            <tbody>{getDepositsList()}</tbody>
        </table>
    );
}

export default DepositsTableShort;
